export const OurData = [
  { name: "Dashboard", link: "/userdashboard/dashboard" },
  { name: "Scenario Planning", link: "/userdashboard/scenarioPlanning" },
  { name: "Balance Score Card", link: "/userdashboard/balancesourceboard" },
  { name: "Import File", link: "/userdashboard/uploadFile" },
  { name: "Settings", link: "/userdashboard/settings" },
];
